// extracted by mini-css-extract-plugin
export default {"chatPage":"chatPage_chatPage__hsHbc"};